var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.order.client && !_vm.order.client.como_verified
      ? _c(
          "div",
          [_c("ComoLoginCode", { attrs: { client: _vm.order.client } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.order.client && _vm.order.client.como_verified
      ? _c("div", { staticClass: "my-10" }, [
          _vm.balance
            ? _c(
                "label",
                {
                  staticClass:
                    "switch on-off-grey withTxt withLabelFullWith mb-0",
                },
                [
                  _c(
                    "span",
                    { staticClass: "labelText flex-start-center pr-10" },
                    [
                      _c("small", { staticClass: "fsize-12 color-grey1" }, [
                        _vm._v("Carte Fidélité"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "em",
                        {
                          staticClass: "fsize-12 text-italic ml-5 color-grey4",
                        },
                        [
                          _vm._v(
                            "( " +
                              _vm._s(_vm.ShopService.prix(_vm.balance)) +
                              " )"
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isUsed() },
                    on: {
                      change: function ($event) {
                        return _vm.toggleComoPayment()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "slider round flex-shrink-0" }, [
                    _c(
                      "small",
                      { staticClass: "flex-center-center h-100 text-bold" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.isUsed() ? "oui" : "non") +
                            "\n\t\t\t\t"
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _c("div", [_vm._m(0)]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "labelText text-bold flex-start-center pr-10" },
      [
        _c("small", { staticClass: "fsize-12 color-grey1" }, [
          _vm._v("Carte Fidélité"),
        ]),
        _vm._v(" "),
        _c("em", { staticClass: "fsize-12 text-italic ml-5 color-ko" }, [
          _vm._v("VIDE"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }